// Design reference only — screenshot at 1200×630
// and save as /public/og-image.png

const OgImagePreview = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center overflow-hidden">
      <div
        className="relative overflow-hidden bg-background"
        style={{ width: 1200, height: 630 }}
      >
        {/* Background — match hero */}
        <div className="absolute inset-0 bg-grid opacity-50" />
        <div className="hero-gradient absolute inset-0" />

        {/* Subdued glow orbs (static) */}
        <div className="absolute left-1/4 top-1/3 h-96 w-96 rounded-full bg-accent/5 blur-[120px]" />
        <div className="absolute right-1/4 bottom-1/3 h-80 w-80 rounded-full bg-primary/5 blur-[100px]" />

        {/* Top-left wordmark */}
        <div className="absolute top-10 left-12 flex items-center gap-3 z-10">
          <img src="/clearslot-logo.svg" alt="" className="h-8 w-8" />
          <span className="text-2xl font-bold tracking-tight text-foreground">
            ClearSlot
          </span>
        </div>

        {/* Center content */}
        <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-20 text-center">
          <h1 className="mb-6 text-5xl font-bold leading-[1.15] tracking-tighter text-foreground">
            A guest books three restaurants for Saturday night.
            <span className="block text-gradient pr-1 pb-2">
              Shows up at one. The two others held the table for nothing.
            </span>
          </h1>

          <p className="text-xl text-muted-foreground">
            Neutral booking coordination infrastructure
          </p>
        </div>

        {/* Bottom-right URL */}
        <div className="absolute bottom-10 right-12 z-10">
          <span className="text-base font-mono text-muted-foreground/70 tracking-wide">
            clearslot.io
          </span>
        </div>
      </div>
    </div>
  );
};

export default OgImagePreview;
